import { useMap } from "react-leaflet";
import { useEffect, useRef } from "react";
import L from "leaflet";
import "leaflet.heat";

const HeatmapLayer = ({ data, visible }) => {
  const map = useMap();
  const heatLayerRef = useRef(null);

  useEffect(() => {
    if (!visible || !data || data.length === 0) {
      if (heatLayerRef.current) {
        map.removeLayer(heatLayerRef.current);
        heatLayerRef.current = null;
      }
      return;
    }

    const heatData = data.map(point => [
      parseFloat(point.latitude),
      parseFloat(point.longitude),
      0.2,
    ]);

    const heatLayer = L.heatLayer(heatData, {
      radius: 22,
      maxZoom: 10,
      minOpacity: 0.1,
    });

    heatLayer.addTo(map);
    heatLayerRef.current = heatLayer;

    return () => {
      if (heatLayerRef.current) {
        map.removeLayer(heatLayerRef.current);
        heatLayerRef.current = null;
      }
    };
  }, [data, visible, map]);

  return null;
};

export default HeatmapLayer;
